const initialStates = {
    CToast: [
        {
            position: 'absolute',
            header: '',
            msg: '',
            class: '',
        }
    ],
    counter: 0,
}

const mutations = {
    set(state, params) {
        state.CToast.push(Object.assign({}, {
            position: 'absolute',
            header: '',
            msg: '',
            class: '',
        }, params))
    },
    increaseCounter(state) {
        state.counter = state.counter + 1
    }
}

const getters = {
    CToast: state => state.CToast,
    CToastCounter: state => state.counter
}

const actions = {
    setCToast({commit}, params) {
        commit('set', params)
        commit('increaseCounter')
    },
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}